import { render, staticRenderFns } from "./forbidden-sheba-filter.vue?vue&type=template&id=5774cbf4"
import script from "./forbidden-sheba-filter.vue?vue&type=script&lang=js"
export * from "./forbidden-sheba-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports